import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import ChooseSide from './routes/ChooseSide';
import Play from './routes/Play';
import { AnimatePresence, motion } from 'framer-motion';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const AnimateRoute = ({ children }: { children: JSX.Element }) => {
    const pageMotion = {
        initial: { opacity: 0 },
        animate: { opacity: 1, transition: { duration: 0.3 } },
        exit: { opacity: 0, transition: { duration: 0.3 } },
    };

    return (
        <motion.div
            initial="initial"
            animate="animate"
            exit="exit"
            variants={pageMotion}
        >
            {children}
        </motion.div>
    );
};

const AnimatedRoutes = () => {
    const location = useLocation();

    return (
        <AnimatePresence exitBeforeEnter>
            <Routes location={location} key={location.pathname}>
                <Route
                    path="/"
                    element={
                        <AnimateRoute>
                            <App />
                        </AnimateRoute>
                    }
                ></Route>
                <Route
                    path="/choose"
                    element={
                        <AnimateRoute>
                            <ChooseSide />
                        </AnimateRoute>
                    }
                />
                <Route
                    path="/play/:side"
                    element={
                        <AnimateRoute>
                            <Play />
                        </AnimateRoute>
                    }
                />
            </Routes>
        </AnimatePresence>
    );
};

root.render(
    <BrowserRouter>
        <AnimatedRoutes />
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
